import { Carousel } from 'components/carousel';

import style from './extension-gallery.module.scss';

type Props = {
  extension: Oneflow.Extension,
};

export const ExtensionGallery = ({ extension }: Props) => {
  const { assets } = extension;
  const gallery = assets?.gallery;
  const galleryCount = gallery?.length || 0;

  if (!gallery || !galleryCount) {
    return null;
  }

  return (
    <div className={style.ExtensionGallery}>
      <Carousel
        count={galleryCount}
        renderSlide={(index) => (
          <img key={`gallery-${index}`} src={gallery[index].url} alt="Gallery" />
        )}
      />
    </div>
  );
};
